var address = {};
module['exports'] = address;
address.country_code = require("./country_code");
address.postcode = require("./postcode");
address.default_country = require("./default_country");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_CH/address/index.js
 ** module id = 383
 ** module chunks = 0
 **/